import { Container, Spinner } from 'react-bootstrap';

import './App.css';
import 'firebaseui/dist/firebaseui.css';

import { Route, Routes } from "react-router-dom";

import AppNav from './AppNav';
import Browse from './BrowsePage';
import { RequireSignin } from './SignInButton';
import Trackers from './TrackersPage';
import LoginPage from './LoginModal';
import { useSelector } from 'react-redux';

const App = () => {
  const loaded = useSelector(state => state.auth.loaded);

  if (!loaded) {
    return (
      <>
        <AppNav />

        <Container className="p-3">
          <Container className="p-lg-5 p-2 pt-3 mb-4 bg-light rounded-3">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Container>
        </Container>
      </>
    );
  }

  return (<>
    <AppNav />

    <Container className="p-3">
      <Routes>
        <Route path="/" element={<Browse />} />
        <Route path="/trackers" element={<RequireSignin><Trackers /></RequireSignin>} />
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    </Container>
  </>
  );
}

export default App;
